<template>

    <i
        v-show="loading"

        class="fad fa-spin fa-spinner text-center">

    </i>

 </template>

<script>
export default {
  name: "ComponentLoadSpinner",
  props: {
    loading: {
      required: true,
      default: false
    }
  }
}
</script>

<style scoped>
i{
  font-size:50px;
  top:45%;
  left:50%;
  position: absolute;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);

}


</style>